// firebase.ts
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore"; // 👈 ye line add karo
const firebaseConfig = {
    apiKey: "AIzaSyCaQgsoiM0g_3drz8AufL4eIMFiKBMIwcE",
    authDomain: "flee-management.firebaseapp.com",
    databaseURL: "https://flee-management-default-rtdb.firebaseio.com",
    projectId: "flee-management",
    storageBucket: "flee-management.firebasestorage.app",
    messagingSenderId: "919971718595",   
    appId: "1:919971718595:web:e8477e7f5ab6bcca764976",
    measurementId: "G-H2JSR6Y1MH"


    
  };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app); // 👈 ye line add karo
export const storage = getStorage(app);
